// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs_tabs__2WrM2","tabContainer":"Tabs_tabContainer__1TY-2"};